import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/icons/CloseModal.svg'


const _hoisted_1 = { class: "infoReservation" }
const _hoisted_2 = { class: "infoReservation__header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "infoReservation__buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GeneralInfoReservation = _resolveComponent("GeneralInfoReservation")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_ctx.showModal)
    ? (_openBlock(), _createBlock(_component_Modal, {
        key: 0,
        onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('closeModal')))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('infoReservation')), 1),
              _createElementVNode("img", {
                src: _imports_0,
                alt: "",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closeModal')))
              })
            ]),
            _createVNode(_component_GeneralInfoReservation, {
              openGeneralInfoReservation: _ctx.openGeneralInfoReservation,
              activeDelivery: _ctx.activeDelivery
            }, null, 8, ["openGeneralInfoReservation", "activeDelivery"]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_Button, {
                variant: "bordered",
                title: _ctx.$t('cancel'),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('closeModal')))
              }, null, 8, ["title"])
            ])
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}